import templateUrl from 'emun.customer/customer-review.htm'
import controller from 'emun.customer/customer-dashboard.controller'

export default {
	bindings: {
		customerId: '@'
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};